import Layout from "../components/Layout";
import {
  BRAND_SLUGS,
  CATEGORY_SLUGS,
  ELECTRIC_SLUG,
  PROVINCE_SLUGS,
  TIER_SLUGS,
} from "../utils/constants";

import Link from "next/link";
import SEO from "../components/SEO";
import { classNames } from "../utils/formatters";
import modelSlugMetadata from "../public/model_slugs.json";

function SubDirectory({
  title,
  slugs,
  displayAsColumns,
}: {
  title: string;
  slugs: Record<any, any>;
  displayAsColumns?: boolean;
}) {
  return (
    <div>
      <h2 className="text-lg font-extrabold tracking-tight text-gray-900">
        {title}
      </h2>
      <div
        className={classNames(
          "gap-y-3 mt-6",
          displayAsColumns
            ? "columns-1 sm:columns-2 md:columns-3"
            : "flex flex-col"
        )}
      >
        {slugs.map((meta: Record<any, any>) => (
          <div
            key={meta.slug || meta.id}
            className={classNames("w-full", displayAsColumns ? "my-3" : 0)}
          >
            <Link href={`/${meta.slug || meta.id}`}>
              <span className="text-cyan-500 hover:text-cyan-400">
                {meta.seo.title}
              </span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function DirectoryPage({ models }) {
  return (
    <div className="pt-4">
      <SEO
        currentURL={`${process.env.NEXT_PUBLIC_ROOT_URL}/collection-acerca-de`}
        title={`Collection by Movi - Acerca de`}
        siteTitle="Movi Autos"
      />
      <main className="max-w-7xl mx-auto mt-8 px-4">
        <h1 className="text-2xl font-extrabold tracking-tight text-gray-900">
          Directorio de autos usados
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-8 mt-3">
          <SubDirectory title="Autos por provincia" slugs={PROVINCE_SLUGS} />
          <SubDirectory title="Autos por estilo" slugs={CATEGORY_SLUGS} />
          <SubDirectory
            title="Otras categorías"
            slugs={[...TIER_SLUGS, ELECTRIC_SLUG]}
          />
        </div>
        <div className="mt-8">
          <SubDirectory
            title="Autos por marca"
            slugs={BRAND_SLUGS}
            displayAsColumns
          />
        </div>
        <div className="mt-8">
          <SubDirectory
            title="Autos por modelo"
            slugs={models}
            displayAsColumns
          />
        </div>
      </main>
    </div>
  );
}

DirectoryPage.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

export const getStaticProps = async () => {
  const models = modelSlugMetadata;

  try {
    return {
      props: {
        models,
      },
    };
  } catch (e) {
    return {
      props: {
        models: [],
      },
    };
  }
};
